import type { RtdbClient } from '@akpl/firebase/client';

import type { TvStoreApi } from '../store';

/** The banner only appears after this long offline (docs/04 §5), so blips stay invisible. */
export const DISCONNECT_GRACE_MS = 5000;

/**
 * Mirrors `.info/connected` into `ui.connected` and raises `ui.reconnecting` (the
 * "Reconectando…" banner) once the socket has been down for `graceMs`.
 */
export function subscribeConnection(
  client: RtdbClient,
  store: TvStoreApi,
  graceMs: number = DISCONNECT_GRACE_MS,
): () => void {
  let timer: ReturnType<typeof setTimeout> | undefined;
  let last: boolean | null = null;

  const unsubscribe = client.onConnected((connected) => {
    if (connected === last) return;
    last = connected;
    const state = store.getState();
    state.setConnected(connected);
    if (timer !== undefined) {
      clearTimeout(timer);
      timer = undefined;
    }
    if (connected) {
      state.setReconnecting(false);
      return;
    }
    timer = setTimeout(() => {
      timer = undefined;
      store.getState().setReconnecting(true);
    }, graceMs);
  });

  return () => {
    if (timer !== undefined) clearTimeout(timer);
    unsubscribe();
  };
}
